import React from 'react';
import {
  Modal,
  Spin,
} from 'antd';
import { SpText } from '../../components/DesignKit';
import { useSelector } from 'react-redux';

type Props = {
  visibility: Boolean,
};

const TransactionProcessingModal = (props: Props) => {
  const {
    visibility
  } = props;

  const isMobileView = useSelector(state => state.cartInfo.isMobileView);

  return (
    <Modal
      centered
      footer={null}
      open={visibility}
      closable={false}
      width={isMobileView ? '95vw' : '50vw'}
      bodyStyle={{ height: '50vh', padding: 0 }} 
    >
      <div 
        className="d-flex flex-column align-items-center justify-content-center w-100" 
        style={{ height: '50vh' }}
      >
        <div className="mb-5">
          {/* Significantly larger loader for the large modal space */}
          <Spin size="large" style={{ transform: 'scale(2)' }} />
        </div>
        <SpText 
          fontSize={isMobileView ? "24px" : "36px"} 
          fontWeight="700" 
          color="#262626" 
          display="block"
          className="text-center"
        >
          Processing...
        </SpText>
        <SpText 
          fontSize={isMobileView ? "16px" : "20px"} 
          color="#595959" 
          display="block"
          className="mt-4 px-5 text-center"
        >
          Please do not close this window.
        </SpText>
      </div>
    </Modal>
  )
};

export default TransactionProcessingModal;
